'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowDown = function (_BaseIcon) {
  (0, _inherits3.default)(ArrowDown, _BaseIcon);

  function ArrowDown() {
    (0, _classCallCheck3.default)(this, ArrowDown);
    return (0, _possibleConstructorReturn3.default)(this, (ArrowDown.__proto__ || (0, _getPrototypeOf2.default)(ArrowDown)).apply(this, arguments));
  }

  (0, _createClass3.default)(ArrowDown, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M.4505905 0h12.6165341L6.75885757 7.56363636'
        }, this.getPathProps()))
      );
    }
  }]);
  return ArrowDown;
}(_BaseIcon3.default);
/*eslint-enable */

ArrowDown.defaultProps = {
  width: 14,
  height: 9,
  viewBox: '0 -1 14 9'
};
exports.default = ArrowDown;
//# sourceMappingURL=ArrowDown.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/ArrowDown.js
// module id = 271
// module chunks = 0